import { combineReducers, configureStore } from '@reduxjs/toolkit';
import creditsSlice from './creditsSlice';
import errorSlice from './errorSlice';
import navigationReducer from './navigationSlice';
import userdataReducer from './userdataSlice';

const rootReducer = combineReducers({
  navigationdata: navigationReducer,
  userdata: userdataReducer,
  errorState: errorSlice,
  creditsData: creditsSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: process.env.NEXT_PUBLIC_ENV !== 'production',
});

export type RootState = ReturnType<typeof rootReducer>;
